import React from 'react';
import { Field, reduxForm, focus } from 'redux-form';
import { registerUser } from '../actions/users';
import { login } from '../actions/auth';
import Input from './input';
import Textarea from './textarea'
import { required, nonEmpty, matches, length, isTrimmed } from '../validators';
import './registration-page.css'

export class RegistrationForm extends React.Component {
    onSubmit(values) {
        const { username, password, firstName, lastName, bio }  = values;
        const user = { username, password, firstName, lastName, bio };
        return this.props
            .dispatch(registerUser(user))
            .then(() => this.props.dispatch(login(username, password)));
    }

    render() {
        return (
            <form
                className="registration-form col-4"
                onSubmit={this.props.handleSubmit(values =>
                    this.onSubmit(values)
                )}>
                <div className='field'>
                    <label className='col-6' htmlFor="firstName">First name</label>
                    <Field 
                        component={ Input } 
                        type="text" 
                        name="firstName" 
                    />
                </div>
                <div className='field'>
                    <label className='col-6' htmlFor="lastName">Last name</label>
                    <Field 
                        component={ Input } 
                        type="text" 
                        name="lastName" 
                    />
                </div>
                <div className='field'>
                    <label className='col-6' htmlFor="username">Username</label>
                    <Field
                        component={ Input }
                        type="text"
                        name="username"
                        validate={ [required, nonEmpty, isTrimmed] }
                    />
                </div>
                <div className='field'>
                    <label className='col-6' htmlFor="password">Password</label>
                    <Field
                        component={ Input }
                        type="password"
                        name="password"
                        validate={ [required, length({min: 10, max: 72}), isTrimmed] }
                    />
                </div>
                <div className='field'>
                    <label className='col-6' htmlFor="passwordConfirm">Confirm password</label>
                    <Field
                        component={ Input }
                        type="password"
                        name="passwordConfirm"
                        validate={ [required, nonEmpty, matches('password')] }
                    />
                </div>
                <div className='field'>
                    <label htmlFor="bio">Bio</label>
                    <Field
                        component={ Textarea }
                        type='text'
                        name='bio'
                        placeholder='Tell us about yourself'
                    />
                </div>
                <button
                    className='register-submit'
                    type="submit"
                    disabled={ this.props.pristine || this.props.submitting }>
                    Register
                </button>
            </form>
        );
    }
}

export default reduxForm({
    form: 'registration',
    onSubmitFail: (errors, dispatch) =>
        dispatch(focus('registration', Object.keys(errors)[0]))
})(RegistrationForm);



// WEBPACK FOOTER //
// ./src/components/registration-form.js